import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '@/views/HomeView.vue';
import GameView from '@/views/GameView.vue';
import GameAboutView from '@/views/GameAboutView.vue'
import GameOptionsView from '@/views/GameOptionsView.vue';
import GameMenuView from '@/views/GameMenuView.vue';
import GameOverviewView from '@/views/GameOverviewView.vue';
import GameBudgetView from '@/views/GameBudgetView.vue';
import GameLeaderboardView from '@/views/GameLeaderboardView.vue';
import GameResultsView from '@/views/GameResultsView.vue';
import QuizView from '@/views/QuizView.vue';
import NotFoundView from '@/views/NotFoundView.vue';

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView,
        meta: {
            hideBackgroundCircleMobile: true,
            pdfButton: true
        }
    },
    {
        path: '/game',
        name: 'game',
        component: GameView,
        meta: {
            budgetButton: true,
            hideBackgroundCircleMobile: true
        },
        children: [
            {
                path: '/game/menu',
                name: 'game-menu',
                component: GameMenuView,
                props: true,
                meta: {
                    hideBackgroundCircleMobile: false
                }
            },
            {
                path: '/game/overview',
                name: 'game-overview',
                component: GameOverviewView,
                meta: {
                    hideBackgroundCircleMobile: false
                }
            },
            {
                path: '/game/budget',
                name: 'budget',
                component: GameBudgetView,
                meta: {
                    hideBackgroundCircleMobile: false
                }
            },
        ]
    },
    {
        path: '/game/about',
        name: 'game-about',
        component: GameAboutView
    },
    {
        path: '/game/options',
        name: 'game-options',
        component: GameOptionsView
    },
    {
        path: '/game/leaderboard',
        name: 'game-leaderboard',
        component: GameLeaderboardView
    },
    {
        path: '/game/results',
        name: 'game-results',
        component: GameResultsView
    },
    {
        path: '/quiz',
        name: 'quiz',
        component: QuizView,
        children: [
            {
                path: '/quiz-start',
                name: 'quiz-start',
                component: QuizView,
                meta: {
                    hideBackgroundCircleMobile: true,
                    pdfButton: true
                }
            },
            {
                path: '/quiz-results',
                name: 'quiz-results',
                component: QuizView,
                meta: {
                    hideBackgroundCircleMobile: true,
                    pdfButton: true
                }
            }
        ]
    },
    {
        path: '/:notFound(.*)',
        component: NotFoundView,
        meta: {
            hideBackgroundCircleMobile: true
        }
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router;
